import axios from "axios";
import { API_ORIGIN } from "./apiConfig";

const USP_BASE_URL = `${API_ORIGIN}/usp`;
const API_BASE_URL = `${API_ORIGIN}/api`;

export interface ProjectPayload {
    title: string;
    description: string;
    category: string;
    status: string;
    year: string;
    location: string;
    imageUrl?: string;
    tags: string[];
    typesOfAssignment: string;
    thematicArea: string;
    subThematicArea: string;
    assignmentType: string;
    subAssignmentType: string;
}

// Auth headers function
const getAuthHeaders = () => {
    const token = localStorage.getItem("admin_access_token");
    return {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
};

// CREATE Project
export const createProject = async (data: ProjectPayload) => {
    try {
        const response = await axios.post(
            `${USP_BASE_URL}/admin/projects`,
            data,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error: any) {
        console.error("Error creating project:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// GET ALL Projects
export const getAllProjects = async () => {
    try {
        const response = await axios.get(
            `${USP_BASE_URL}/admin/projects`,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error: any) {
        console.error("Error fetching projects:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// DELETE Project
export const deleteProject = async (projectId: string) => {
    try {
        const response = await axios.delete(
            `${USP_BASE_URL}/admin/projects/${projectId}`,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error: any) {
        console.error("Error deleting project:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// GET Project by ID
export const getAdminProjectById = async (projectId: string) => {
    try {
        const response = await axios.get(
            `${USP_BASE_URL}/admin/projects/${projectId}`,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error: any) {
        console.error(`Error fetching admin project ${projectId}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// UPDATE Project
export const updateProject = async (projectId: string, data: ProjectPayload) => {
    try {
        const response = await axios.put(
            `${USP_BASE_URL}/admin/projects/${projectId}`,
            data,
            { headers: getAuthHeaders() }
        );
        return response.data;
    } catch (error: any) {
        console.error(`Error updating project ${projectId}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

export const getPublicProjects = async () => {
    try {
        const response = await axios.get(`${USP_BASE_URL}/projects`);
        return response.data;
    } catch (error: any) {
        console.error("Error fetching public projects:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

export const getProjectById = async (id: string) => {
    try {
        const response = await axios.get(`${USP_BASE_URL}/projects/${id}`);
        return response.data;
    } catch (error: any) {
        console.error(`Error fetching project ${id}:`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

export const searchProjects = async (keyword: string) => {
    try {
        const response = await axios.get(`${USP_BASE_URL}/projects/search`, {
            params: { keyword },
        });
        return response.data;
    } catch (error: any) {
        console.error(`Error searching projects with keyword "${keyword}":`, error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

// Media Upload Service - DIRECT TOKEN USE KAREGA
export const mediaService = {
    uploadMedia: async (files: any[], additionalData: any = {}) => {
        try {
            const formData = new FormData();
            const token = localStorage.getItem("admin_access_token");

            // Append each file
            files.forEach((fileObj) => {
                formData.append('files', fileObj.file); // Actual File object
            });

            // Append additional data
            Object.keys(additionalData).forEach(key => {
                formData.append(key, additionalData[key]);
            });

            const response = await axios.post(`${API_BASE_URL}/assets/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...(token ? { Authorization: `Bearer ${token}` } : {})
                },
            });

            return response.data;
        } catch (error: any) {
            if (error.response) {
                throw new Error(`API Error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`);
            } else if (error.request) {
                throw new Error('Network error: No response from server');
            } else {
                throw new Error(`Request error: ${error.message}`);
            }
        }
    },

    // Method to delete media by fileName
    deleteMedia: async (fileName: string) => {
        try {
            const token = localStorage.getItem("admin_access_token");
            const response = await axios.delete(`${API_BASE_URL}/assets/delete/${fileName}`, {
                headers: {
                    ...(token ? { Authorization: `Bearer ${token}` } : {})
                }
            });
            return response.data;
        } catch (error: any) {
            if (error.response) {
                throw new Error(`API Error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`);
            } else if (error.request) {
                throw new Error('Network error: No response from server');
            } else {
                throw new Error(`Request error: ${error.message}`);
            }
        }
    },
};